/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SeasonProgressionSourceType = {
    QUEST_COMPLETION: 'QUEST_COMPLETION',
    GAME_SESSION: 'GAME_SESSION',
    STREAK_WINDOW: 'STREAK_WINDOW',
    COMPETITION_ENTRY: 'COMPETITION_ENTRY',
    BRAND_ACTIVATION: 'BRAND_ACTIVATION',
    BADGE_OWNERSHIP: 'BADGE_OWNERSHIP'
} as const;
export type SeasonProgressionSourceType = typeof SeasonProgressionSourceType[keyof typeof SeasonProgressionSourceType];


export function instanceOfSeasonProgressionSourceType(value: any): boolean {
    for (const key in SeasonProgressionSourceType) {
        if (Object.prototype.hasOwnProperty.call(SeasonProgressionSourceType, key)) {
            if (SeasonProgressionSourceType[key as keyof typeof SeasonProgressionSourceType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SeasonProgressionSourceTypeFromJSON(json: any): SeasonProgressionSourceType {
    return SeasonProgressionSourceTypeFromJSONTyped(json, false);
}

export function SeasonProgressionSourceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeasonProgressionSourceType {
    return json as SeasonProgressionSourceType;
}

export function SeasonProgressionSourceTypeToJSON(value?: SeasonProgressionSourceType | null): any {
    return value as any;
}

export function SeasonProgressionSourceTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): SeasonProgressionSourceType {
    return value as SeasonProgressionSourceType;
}

